import styled from 'styled-components';

interface TopBarWrapperProps {
  height?: string;
  padding?: string;
  gap?: string;
  backgroundColor?: string;
  children: React.ReactNode;
  className?: string;
}

const StyledTopBarWrapper = styled.div<TopBarWrapperProps>`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ height }) => height || '60px'};
  padding: ${({ padding }) => padding || '0 20px'};
  gap: ${({ gap }) => gap || '10px'};
  background-color: ${({ backgroundColor }) => backgroundColor || '#fff'};
  border-bottom: 1px solid #eceff3;
`;

const TopBarWrapper: React.FC<TopBarWrapperProps> = ({
  height,
  padding,
  gap,
  backgroundColor,
  children,
  className,
}) => {
  return (
    <StyledTopBarWrapper
      height={height}
      padding={padding}
      gap={gap}
      backgroundColor={backgroundColor}
      className={className}
    >
      {children}
    </StyledTopBarWrapper>
  );
};

export { TopBarWrapper };
